module.exports = __webpack_public_path__ + "static/media/2x3.040ba139.png";